import { useState, useEffect } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import Input from "../../components/input";
import FIlterSelect from "../../components/filter-select";
import {
    capitalizeFirstLetter
} from "../../utilz/function";
import ActionModal from "./action-modal";
import useRequest from "../../components/hooks/use-request";
import { showToast } from "../../components/toast";

interface RegionData {
    _id: string;
    regionName: string;
    sourcingOfficers: any;
    sourcingState:any
}

interface RegionTableProps {
    data: RegionData[];
}


const RegionsTable: React.FC<RegionTableProps>  = ({data}) => {
    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState<RegionData[]>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [modalConfig, setModalConfig] = useState<{
        isVisible: boolean;
        actionType: "delete";
        selectedRegionId: string | null;
    }>({
        isVisible: false,
        actionType: "delete",
        selectedRegionId: null,
    });


    const { makeRequest: deleteRegion } = useRequest(
        modalConfig.selectedRegionId ? `/region/${modalConfig.selectedRegionId}` : "",
        "DELETE"
    );




    const columns = [
        { header: "Region Name", accessor: "regionName"},
        { header: "Sourcing Officers", accessor: "sourcingOfficers"},
        // { header: "Sourcing State", accessor: "sourcingState"},
        { header: "Actions", accessor: "_id" },
    ]

    const handleUserClick = (_id: string) => {
        navigate(`/dashboard/regions/${_id}`);
    };
    const handleDeleteClick = (_id: string) => {
        setModalConfig({
            ...modalConfig,
            isVisible: true,
            selectedRegionId: _id,
            actionType: "delete"
        });
    };

    useEffect(() => {
        const filtered = data?.filter((regions) => {
            
    
          const searchMatch =
            !searchQuery ||
            regions?.regionName
              ?.toLowerCase()
              .includes(searchQuery?.toLowerCase())
          
    
          return searchMatch;
        })
        setFilteredData(filtered)
    }, [data, searchQuery]);

    const combinedData = filteredData?.map((regions) => ({
        ...regions,
        
        name: (
            <div>
                <div>{capitalizeFirstLetter(regions?.regionName) || "N/A"}</div>
            </div>
        ),
        sourcingOfficers: (
            <div className="flex gap-3 flex-wrap">
                {regions?.sourcingOfficers?.length > 0 ? (
                    regions.sourcingOfficers.map((officer: any, index: number) => (
                        <div key={index} className="flex gap-2">{officer.username || "N/A"},</div> 
                    ))
                ) : (
                    <div>No sourcing officers assigned</div>
                )}
            </div>
        ),
         sourcingState: (
            <div>
                <div>{capitalizeFirstLetter(regions?.sourcingState) || "N/A"}</div>
            </div>
        ),
           
           
    }));

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };
    const handleConfirmAction = async() => {
        const [response] = await deleteRegion()
        if (response?.status) {
            showToast(response.message, true);
            window.location.reload();
            } else {
            showToast(response?.message, false);
        }
    }



    return ( 
        <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
            <div className="md:flex justify-between px-5">
                <p className="text-[20px] font-bold">Sourcing Regions</p>

                <div className="md:flex gap-2 items-center md:mt-0 mt-2">
                    <Input
                        name="search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="w-full"
                        placeholder="Search"
                        icon="searchIcon"
                    />
                </div>
            </div>

            {combinedData?.length > 0 ? (
                <Table
                    columns={columns}
                    data={combinedData}
                    selectedUserId={null}
                    onUserClick={handleUserClick}
                    onDeleteClick={handleDeleteClick}
                />
            ) : (
                <div className="opacity-80 mt-10 font-bold text-center mx-auto">
                No Region found
                </div>
            )}

            <ActionModal
                visible={modalConfig.isVisible}
                onCancel={() =>
                    setModalConfig({ ...modalConfig, isVisible: false })
                }
                onConfirm={handleConfirmAction}
                title={
                    modalConfig.actionType === "delete"
                        ? "Delete Sourcing Region"
                        : "nill"
                }
                content={`Are you sure you want to ${modalConfig.actionType} this Sourcing Region?`}
                actionType={modalConfig.actionType}
            />
            
           
        </div>

        
    );
}
 
export default RegionsTable;